var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wet-header-message p-1 p-sm-3 text-center",class:{
    'text-primary': _vm.highlight,
    'wet-note': !_vm.highlight,
    'font-weight-bold': _vm.highlight,
  }},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }